import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_PATH } from '../../core/constants';

export const getProductsForDocumentAction = createAsyncThunk(
    'product/getProductsForDocumentAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PRODUCTS_PATH }/document${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductsForDocumentSlice = createSlice({
    name: 'getProductsForDocumentSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateProductsForDocument() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getProductsForDocumentAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductsForDocumentAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductsForDocumentAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateProductsForDocument } = getProductsForDocumentSlice.actions;
export const getProductsForDocumentState = (state) => state.product.getProductsForDocument;
export default getProductsForDocumentSlice.reducer;
